import type { InputProps } from '../Input/types'

export interface InputPasswordProps extends InputProps {
	ariaLabelShow: string
	ariaLabelHide: string
	id: string
}

export const enum InputType {
	TEXT = 'text',
	PASSWORD = 'password',
}
